/**
 * Enum representing the possible statuses of a payment in the system.
 * Used to track the lifecycle of payment transactions.
 */
export enum PaymentStatusEnum {
  /**
   * Payment has been initiated but not yet completed.
   * The guest has not yet submitted payment information.
   */
  PENDING = 'PENDING',

  /**
   * Payment has been successfully completed.
   * The transaction was processed and funds were received.
   */
  PAID = 'PAID',

  /**
   * Payment link or session has expired.
   * The guest did not complete the payment within the allowed time.
   */
  EXPIRED = 'EXPIRED',

  /**
   * Payment was cancelled by the guest or hotel staff.
   * The transaction was intentionally stopped before completion.
   */
  CANCELLED = 'CANCELLED',

  /**
   * Payment is currently being processed.
   * The guest has submitted payment information and the transaction is being verified.
   */
  IN_PROGRESS = 'IN_PROGRESS',

  /**
   * Payment processing failed.
   * There was an error during the payment transaction.
   */
  FAILED = 'FAILED',

  /**
   * Payment link has been generated but not yet sent or accessed.
   * Named in mixed case for backward compatibility with persisted records.
   */
  Generated = 'Generated',
}
